import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './auth.component';
import { LoaderPageComponent } from './loaderPage/loaderPage.component';

const routes: Routes = [
    { path: '', component: AuthComponent },
    {
        path: 'spinnerPage',
        component: LoaderPageComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AuthRoutingModule {
}


// WEBPACK FOOTER //
// ./src/app/auth/auth-routing.routing.ts